<template>
<!-- 活动详情 -->
<div>
  <div v-if="basicinfo" style="width: 95%;margin: auto;padding-bottom: 20px;">
    <p class="boldTitle">基本信息</p>
    <el-form label-width="80px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="活动名称：">
            <el-input v-model="hdmc" placeholder="请输入活动名称（5-30个字）" style="width:80%"
              maxlength="30" minlength="5" :disabled="isEdit == 2"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="活动日期：">
            <el-date-picker type="daterange" v-model="hdTime" @change="changeActiveTime"
              value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期"
              :picker-options="pickerOptionsStart" :disabled="isEdit == 2"
              style="width:80%;cursor:pointer;background:#fff;border:1px solid #eee;"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="活动主图：" prop="bannerImgUrl" class="uploadActiveForm">
            <div class="uploadActive">
              <el-upload class="avatar-uploader activeUploadImg"
                style action :show-file-list="false" :disabled="isEdit == 2"
                :before-upload="(file)=>beforeAvatarUpload(file, 1)">
                <div class="bannerImgUrl" v-if="bannerImgUrl">
                  <el-image :src="bannerImgUrl" fit="cover" style="width: 80px; height: 80px"/>
                </div>
                <div v-if="!bannerImgUrl" class="bannerImgUrl">
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                </div>
              </el-upload>
            </div>
            <div style="color:#888;">尺寸要求：1200*675，支持的图片格式：jpg、png；不超过5MB</div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="分享封面：" prop="fxfmImgUrl" class="uploadActiveForm">
            <div class="uploadActive">
              <el-upload class="avatar-uploader activeUploadImg"
                style action :show-file-list="false" :disabled="isEdit == 2"
                :before-upload="(file)=>beforeAvatarUpload(file, 2)">
                <div class="fxfmImgUrl" v-if="fxfmImgUrl">
                  <el-image :src="fxfmImgUrl" fit="cover" style="width: 80px; height: 80px"/>
                </div>
                <div v-if="!fxfmImgUrl" class="fxfmImgUrl">
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                </div>
              </el-upload>
            </div>
            <div style="color:#888;">尺寸要求：1000*800，支持的图片格式：jpg、png；不超过5MB</div>
          </el-form-item>
        </el-col>
        <canvas id="canvasa" hidden/>
      </el-row>
    </el-form>
    <p class="boldTitle">活动配置</p>
    <el-row :span="24" style="width: 100%;margin: auto;border: 1px solid #eee;">
      <!-- 排版左 活动形式 -->
      <el-col :span="3" class="activityFormClass">
        <ul class="ulhdpz">
          <li :class="{active:index==isactive}" v-for="(item, index) in leftActivityFormList" :key="index"
           :value="item.id" :label="item.name" @click="handleCurrentChange(item,index)">{{ item.name }}</li>
        </ul>
        <!-- <el-tabs tab-position="left" style="height: 200px;" v-model="activityId" @tab-click="handleCurrentChange">
          <el-tab-pane v-for="(item, index) in leftActivityFormList" :key="index"
           :label="item.name" :name="item.id" :data-actid="item.ActivityId"/>
        </el-tabs> -->
      </el-col>
      <!-- 排版右 列表 -->
      <!-- box-shadow: 0px 1px 10px 0px rgba(14, 5, 10, 0.1); -->
      <el-col :span="21">
        <section class="model_section">
          <el-col :span="14">
            <b style="margin-left: 20px;">{{zidingyiB}}</b>
          </el-col>
          <div class="divBtn" v-show="isEdit != 2">
            <!-- <button class="setUpCoCreation" @click="endSetUp()"
              v-if="activityId == 4"> 共创推广优惠券佣金上限: 
              <b v-if="this.shangxian">{{this.shangxian}}</b> <b v-else> 0 </b> 元
            </button> -->
            <el-button type="primary" @click="configuretitle()" v-show="activityId != 10">配置标题</el-button>
            <el-button type="danger" @click="addRelatedBrand()"
            v-if="activityId == 1 || activityId == 2 || activityId == 3 || activityId == 4 || activityId == 8 || activityId == 9 || activityId == 10"> 新增 </el-button>
            <el-button type="danger" @click="addRelatedBrand()"
            v-if="(activityId == 5 || activityId == 6 || activityId == 7) && (dataList.length != 1 || dataList == null)"> 新增 </el-button>
          </div>
        </section>
        <!-- table 列表 -->
        <div class="table_container">
          <div class="table_inner_container" style="height: auto">
            <el-table :data="dataList" class="invoice_tab" stripe border style="height: auto;">
              <el-table-column label="序号" align="center" width="50" key="1">
                <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
              </el-table-column>
              <template v-if="activityId != 4">
                <el-table-column label="店铺" align="center" v-if="activityId == 1 || activityId == 2 || activityId == 3">
                  <template scope="scope">
                    <span class="spanList" :title="scope.row.brandName">{{ scope.row.brandName }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="商品编码" align="center" v-if="activityId == 1 || activityId == 2 || activityId == 3">
                  <template scope="scope">
                    <span class="spanList">{{ scope.row.goodModelCode }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="商品名称" align="center" v-if="activityId == 1 || activityId == 2 || activityId == 3">
                  <template scope="scope">
                    <span class="spanList">{{ scope.row.title }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="市场价" align="center" v-if="activityId == 1 || activityId == 2 || activityId == 3">
                  <template scope="scope">
                    <span class="spanList">{{ scope.row.marketPrice }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="礼品名称" align="center" v-if="activityId == 5 || activityId == 6 || activityId == 7">
                  <template scope="scope">
                    <span class="spanList">{{ scope.row.name }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="礼品数量" align="center" v-if="activityId == 5 || activityId == 6 || activityId == 7">
                  <template scope="scope">
                    <span class="spanList">{{ scope.row.number }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="核销时间" align="center" v-if="activityId == 5">
                  <template scope="scope">
                    <span class="spanList">{{ scope.row.datetime }}</span>
                  </template>
                </el-table-column>
                <div v-if="activityId == 8">
                  <el-table-column label="店铺" align="center">
                    <template scope="scope">{{ scope.row.shopname }}</template>
                  </el-table-column>
                  <el-table-column label="商品编码" align="center">
                    <template scope="scope">{{ scope.row.goodscode }}</template>
                  </el-table-column>
                  <el-table-column label="商品名称" align="center">
                    <template scope="scope">{{ scope.row.goodsname }}</template>
                  </el-table-column>
                  <el-table-column label="商品类型" align="center">
                    <template scope="scope">{{ scope.row.goodstypename }}</template>
                  </el-table-column>
                  <el-table-column label="状态" align="center">
                    <template scope="scope">{{ scope.row.isonsalename }}</template>
                  </el-table-column>
                </div>
                <el-table-column label="活动号码" align="center" v-if="activityId == 9">
                  <template scope="scope">{{ scope.row.smackercode }}</template>
                </el-table-column>
                <el-table-column label="小标题名称" align="center" key="1" v-if="activityId == 10">
                  <template scope="scope">{{ scope.row.remark }}</template>
                </el-table-column>
                <el-table-column label="图片内容" align="center" v-if="activityId == 10">
                  <template scope="scope">
                    <span @click="seebigimg(scope.row)" style="color:#0099FF">预览</span>
                  </template>
                </el-table-column>
              </template>
              <template v-else>
                <el-table-column label="优惠券名称" prop="name" align="center">
                  <template scope="scope">
                    <span class="spanList">{{ scope.row.name }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="面值" prop="facevalue" align="center">
                  <template scope="scope">
                    <span class="spanList">{{ scope.row.facevalue }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="使用条件" prop="usethreshold" align="center">
                  <template scope="scope">
                    <span class="spanList">{{ scope.row.usethreshold }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="售价" prop="price" align="center">
                  <template scope="scope">
                    <span class="spanList">{{ scope.row.price }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="适用店铺" prop="shopname" align="center">
                  <template scope="scope">
                    <span class="spanList">{{ scope.row.shopname }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="优惠券数量" prop="number" align="center">
                  <template scope="scope">
                    <span class="spanList">{{ scope.row.number }}</span>
                  </template>
                </el-table-column>
              </template>
              
              <el-table-column label="促销价" align="center" v-if="activityId == 1">
                <template scope="scope">
                  <span class="spanList">{{ scope.row.promotionPrice }}</span>
                </template>
              </el-table-column>
              <el-table-column label="秒杀价" align="center" v-if="activityId == 2">
                <template scope="scope">
                  <span class="spanList">{{ scope.row.seckillPrice }}</span>
                </template>
              </el-table-column>
              <el-table-column label="数量" align="center" v-if="activityId == 2">
                <template scope="scope">
                  <span class="spanList">{{ scope.row.seckillStock }}</span>
                </template>
              </el-table-column>
              <el-table-column label="团购价" align="center" v-if="activityId == 3">
                <template scope="scope">
                  <span class="spanList">{{ scope.row.groupPrice }}</span>
                </template>
              </el-table-column>
              <el-table-column label="成团人数" align="center" v-if="activityId == 3">
                <template scope="scope">
                  <span class="spanList">{{ scope.row.groupNumber }}</span>
                </template>
              </el-table-column>
              <el-table-column label="佣金" align="center" v-if="activityId == 2 || activityId == 3">
                <template scope="scope">
                  <span class="spanList">{{ scope.row.commissionRate }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="甄惠装价" align="center" v-if="activityId == 5">
                <template scope="scope">
                  <span class="spanList">{{ scope.row.tzrPrice }}</span>
                </template>
              </el-table-column> -->
              <el-table-column label="操作" fixed="right" width="235" align="center">
                <template scope="scope">
                  <span class="handle" v-if="isEdit != 2 && activityId != 8 && activityId != 9" @click="handleActivity(scope.row)">
                    <i class="el-icon-edit-outline"></i> 修改
                  </span>
                  <span class="handle" v-if="isEdit != 2" @click="deleteBrand(scope.row)">
                    <i class="el-icon-delete"></i> 删除
                  </span>
                  <span class="handle" v-if="activityId == 9" @click="spUpordown(scope.row, 1)" v-show="scope.$index > 0">
                    <i class="el-icon-upload2" /> 向上
                  </span>
                  <span class="handle" v-if="activityId == 9" @click="spUpordown(scope.row, 2)" v-show="scope.$index < dataList.length - 1">
                    <i class="el-icon-download" /> 向下
                  </span>
                  <!-- <span class="handle" v-if="activityId==9||activityId==10">-</span> -->
                  <span v-else>
                    <span class="handle" v-if="isEdit == 2" @click="seeinfo(scope.row, 3)"><i class="el-icon-view"></i> 查看 </span>
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-col>
    </el-row>
    <p class="boldTitle">活动详情</p>
    <wjEditor :desc="ueditorValue" @change="contentChangeOne"/>
    <p class="boldTitle">付费推广
      <span style="font-weight: normal; font-size: 12px; color:#999;">（活动结束后未使用的推广费用，5个工作日内将自动退款到原微信支付账户。）</span>
    </p>
    <p class="boldTitle">引客到店奖现金：
      <el-button type="danger" @click="configuration(3)" v-show="isEdit != 2">配置</el-button>
      <template v-if="seejlfsOne !=''">
        <span class="threePrice">单份奖励：{{rewardOne}}元</span>
        <span class="threePrice">奖励份数：{{seejlfsOne}}份</span>
        <!-- <span class="threePrice">需充值金额：{{Math.ceil(rechargeAmountOne*100)/100}} 元（微信收取{{wxrate*1000}}‰手续费）</span> -->
        <span class="threePrice">需充值金额：{{Math.ceil(rechargeAmountOne*100)/100}} 元</span>
      </template>
      <template v-else>
        <span class="threePrice">无配置</span>
      </template>
      <el-button type="primary" @click="chongzhiPz(1)" v-show="isEdit != 2 && seejlfsOne != ''" style="margin-left: 10px;">重置</el-button>
    </p>
    <p class="boldTitle">创客分享奖现金：
      <el-button type="danger" @click="configuration(2)" v-show="isEdit != 2">配置</el-button>
      <template v-if="seejlfsTwo !=''">
        <span class="threePrice">单份奖励：{{rewardTwo}}元</span>
        <span class="threePrice">奖励份数：{{seejlfsTwo}}份</span>
        <!-- <span class="threePrice">需充值金额：{{Math.ceil(recharge.totalprice*100)/100}} 元（微信收取{{wxrate*1000}}‰手续费）</span> -->
        <span class="threePrice">需充值金额：{{Math.ceil(recharge.totalprice*100)/100}} 元</span>
      </template>
      <template v-else>
        <span class="threePrice">无配置</span>
      </template>
      <el-button type="primary" @click="chongzhiPz(2)" v-show="isEdit != 2 && seejlfsTwo !=''" style="margin-left: 10px;">重置</el-button>
    </p>
    <!-- 底部操作按钮 -->
    <div class="gudingdibu">
      <el-button @click="resetForm()">{{ isEdit==2?'返回':'取消' }}</el-button>
      <el-button type="danger" @click="addedit(0)" v-show="isEdit != 2">确定</el-button>
    </div>
  </div>
  <addActiviteForm v-else ref="addActiviteForm" @cancelActiveForm="cancelActiveForm"
   @newAdd="newlyAdded" :activityTypeFrom="activityTypeFrom"/>
  <!-- 自定义标题-弹框 -->
  <el-dialog title="自定义标题" :visible.sync="zidingyiTitle" width="25%">
    <el-form>
      <el-form-item style="width:100%">
        <el-input v-model="activitiesName" placeholder="自定义标题（10个字以内）" maxlength="11"/>
      </el-form-item>
    </el-form>
    <div style="padding-left:0;text-align:center">
      <el-button @click="zidingyiTitle = false">取消</el-button>
      <el-button type="danger" @click="complete()">确定</el-button>
    </div>
  </el-dialog>
  <!-- 共创推广优惠券佣金上限-弹框 -->
  <el-dialog title="共创推广优惠券佣金上限" :visible.sync="isToExamine" width="30%">
    <el-form>
      <el-form-item style="width:100%">
        <el-input v-model="upperLimit" placeholder="请输入共创推广优惠券佣金上限" maxlength="20"/>
      </el-form-item>
    </el-form>
    <!-- 弹框按钮 确定/取消 -->
    <div style="padding-left:0;text-align:center">
      <button type="button" @click="isToExamine = false"
        class="el-button el-button--default cancle normal_btn">取消</button>
      <button type="button" @click="editSubmit()"
        class="el-button el-button--default search_btn normal_btn">保存</button>
    </div>
  </el-dialog>
  <!-- 幸运购-弹框 -->
  <el-dialog title="幸运购" :visible.sync="yiyuan" width="25%">
    <el-form>
      <el-form-item style="width:100%">
        <el-input v-model="yyqHdhm" placeholder="请输入幸运购活动号码    例：230307001" maxlength="11"/>
      </el-form-item>
      <!-- <div style="line-height: 10px;padding:0 0 10px 5px;">
        <b style="color: #F56C6C;">温馨提示：</b>
        <p>如需添加幸运购活动号码，请联系400-1577-588。</p>
      </div> -->
    </el-form>
    <div style="padding-left:0;text-align:center">
      <button type="button" @click="yiyuan = false"
        class="el-button el-button--default cancle normal_btn">取消</button>
      <button type="button" @click="yyqSubmit()"
        class="el-button el-button--default search_btn normal_btn">保存</button>
    </div>
  </el-dialog>
  <!-- 小标题 -->
  <el-dialog title="小标题" :visible.sync="seeTksh" :center="true" width="30%">
    <el-input v-model="shenmark" placeholder="请输入小标题（10个字以内）" maxlength="10"/>
    <div style="width: 100%;margin: 10px 0;">
      <div class="multigraph" v-for="(img,index) in images" :key="index" :data-img="img">
        <el-image :src="img" fit="cover" style="width: 80px; height:80px"/>
        <div class="chahao" @click.stop="deldetail(index)">
          <img src="../../assets/img/aicon36.png"/>
        </div>
      </div>
      <el-upload action multiple v-if="images.length < 10" accept=".png, .jpg,.jpeg"
      :limit="10" :before-upload="(file)=>multiGraphUpload(file)">
        <i class="el-icon-plus upBtn"></i>
      </el-upload>
    </div>
    <div style="color:#888;font-size: 13px;">建议宽为1200像素，高不限，支持的图片格式：jpg、png。最大不超过5MB，最多支持上传10张。</div>
    <div style="padding-top:10px;text-align:center">
      <el-button @click="seeTksh = false">取 消</el-button>
      <el-button type="danger" @click="qdTksh()">确定</el-button>
    </div>
  </el-dialog>
  <!-- 引客到店奖现金 & 创客分享奖现金 -->
  <el-dialog :title="jxjTitle" :visible.sync="prizeCash" :center="true" width="50%" top="50px">
    <el-form style="display:flex;">
      <el-form-item label="单份奖励：" style="display:flex;margin-bottom:0;">
        <el-input v-model="rewardOne" placeholder="请输入" style="width:80%"
        onkeyup="this.value=this.value.replace(/\D|^0/g,'')" v-if="peizhiType==3">
        <i slot="suffix" style="margin-right: 10px;">元</i>
        </el-input>
        <el-input v-model="rewardTwo" placeholder="请输入" style="width:80%"
        onkeyup="this.value=this.value.replace(/\D|^0/g,'')" v-else>
        <i slot="suffix" style="margin-right: 10px;">元</i>
        </el-input>
      </el-form-item>
      <el-form-item label="奖励份数：" style="display:flex;margin-bottom:0;">
        <el-input v-model="shareOne" placeholder="请输入奖励份数" maxlength="7" style="width:80%" v-if="peizhiType==3"/>
        <el-input v-model="recharge.totalcount" placeholder="请输入奖励份数" maxlength="7" style="width:80%" v-else/>
      </el-form-item>
      <template>
        <el-form-item label="充值金额：" style="display:flex;margin-bottom:0;" v-if="peizhiType==3">
          <!-- <span><b style="color: #F56C6C;">{{Math.ceil(rechargeAmountOne*100)/100}}</b> 元（含微信收取{{wxrate*1000}}‰手续费）</span> -->
          <span><b style="color: #F56C6C;">{{Math.ceil(rechargeAmountOne*100)/100}}</b> 元</span>
        </el-form-item>
        <el-form-item label="充值金额：" style="display:flex;margin-bottom:0;" v-else>
          <!-- <span><b style="color: #F56C6C;">{{Math.ceil(recharge.totalprice*100)/100}}</b> 元（含微信收取{{wxrate*1000}}‰手续费）</span> -->
          <span><b style="color: #F56C6C;">{{Math.ceil(recharge.totalprice*100)/100}}</b> 元</span>
        </el-form-item>
      </template>
    </el-form>
    <p style="color: #F56C6C;" v-show="peizhiType==3">重要提示：<span>　本功能需要配置签到礼品</span></p>
    <div v-show="peizhiType==2">
      <el-form>
        <el-form-item label="分享规则：" style="margin-bottom: 5px;">
          <el-radio-group v-model="fxdpyq">
            <el-radio v-for="item in tasktyps" :key="item.bttid" :label="item.bttid" style="margin-right: 15px;">{{item.tasktypename}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="分享文案：" style="display:flex;margin-bottom:0;">
          <el-input type="textarea" v-model="recharge.remark" :rows="2" placeholder="请输入分享文案内容" maxlength="100" show-word-limit/>
        </el-form-item>
        <el-form-item label="分享要求：" style="margin-bottom: 10px;">
          <!-- <div v-if="tasktyps.length>0">
            <div v-if="get_description('pyq').length > 0" style="margin-bottom: -5px;">【朋友圈】</div>
            <div v-for="(item,index) in get_description('pyq')" :key="index">
              <div style="color: #999;line-height: 25px;">{{index+1}}.{{item}}</div>
            </div>
            <div v-if="get_description('wxq').length > 0" style="margin-bottom: -5px;">【微信群】</div>
            <div v-for="(item,index) in get_description('wxq')" :key="index">
              <div style="color: #999;line-height: 25px;">{{index+1}}.{{item}}</div>
            </div>
          </div> -->
          <div v-if="tasktyps.length>0" style="display: inline-block;">
            <ul v-for="(desc, index) in tasktyps.find(t => t.bttid == fxdpyq).descriptions" :key="index">
              <li v-if="desc.taskdesc.startsWith('【朋友圈】') || desc.taskdesc.startsWith('【微信群】')" style="font-weight: bold;">
                {{ desc.taskdesc }}
              </li>
              <li v-else style="color: #999;line-height: 30px;">
                {{ desc.taskdesc }}
              </li>
            </ul>
          </div>
        </el-form-item>
      </el-form>
      <div style="margin-bottom: 20px;">创客范围：<span>【本功用于配置哪些创客来进行推广】</span></div>
      <span style="float: left;">按从事行业：</span>
      <div style="width: 800px;">
        <el-checkbox-group v-model="formmenuOne" @change="handleCheckedCities" style="margin-bottom: 20px;">
          <el-checkbox v-for="item in industry" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
        </el-checkbox-group>
      </div>
      <div style="height: 200px;display: flex;" v-show="formmenuOne.find(i=>i==2)">
        <span style="float: left;">按建材品类：</span>
        <div style="overflow-y: scroll;display: grid;padding: 0 10px 0 0;">
          <el-checkbox v-model="checkAlltwo" :indeterminate="isIndeterminateTwo" @change="handleCheckAllChange(checkAlltwo,2)">
            全部
          </el-checkbox>
          <el-tree ref="tree" show-checkbox :data="category" node-key="id" style="margin-top: 5px;"
          highlight-current :props="defaultProps" class="cktree" :default-checked-keys="formmenuTwo"/>
        </div>
      </div>
    </div>
    <!-- <div style="width: 500px;background: #F2F2F2;padding: 10px 0;" v-show="peizhiType==2">
      <el-row style="display: flex;justify-content: space-between;padding-bottom: 10px;">
        <el-col :span="11"><b>按行业选择</b></el-col>
        <el-col :span="11"><b>按品类选择</b></el-col>
      </el-row>
      <el-row style="height: 200px;display: flex;justify-content: space-between;">
        <el-col :span="11" style="overflow-y: scroll;display: grid;background: #fff;padding: 10px 0 0 24px;">
          <el-checkbox v-model="checkAllone" :indeterminate="isIndeterminateOne" @change="handleCheckAllChange(checkAllone,1)">
            全部
          </el-checkbox>
          <el-checkbox-group v-model="formmenuOne" @change="handleCheckedCities" style="margin-top: -10px;">
            <el-checkbox v-for="item in industry" :label="item.id" :key="item.id" style="line-height: 30px;">{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </el-col>
        <el-col :span="11" style="overflow-y: scroll;display: grid;background: #fff;padding: 10px 0 0 24px;">
          <el-checkbox v-model="checkAlltwo" :indeterminate="isIndeterminateTwo" @change="handleCheckAllChange(checkAlltwo,2)"> 全部 </el-checkbox>
          <el-tree ref="tree" show-checkbox :data="category" node-key="id" style="margin-top: 5px;"
          highlight-current :props="defaultProps" class="cktree" :default-checked-keys="formmenuTwo"/>
        </el-col>
      </el-row>
    </div> -->
    <b style="display: block;margin: 10px 0;">付费推广目的：</b>
    <ul v-show="peizhiType==3">
      <li style="line-height: 32px;" v-for="(item, index) in ykddjxj" :key="index">{{item.name}}</li>
    </ul>
    <ul v-show="peizhiType==2">
      <li style="line-height: 32px;" v-for="(item, index) in ckfxjxj" :key="index">{{item.name}}</li>
      <li style="margin-top: 5px;">4.示例截图</li>
      <ul class="videoandpic" v-if="tasktyps.length>0">
        <!--  @click="handleplay(item)" -->
        <li v-for="(item, index) in tasktyps.find(i=>i.bttid==fxdpyq).examples" :key="index">
          <!-- <el-image :src="baseOssUrl+item.videoimg" style="width: 100px; height: 100px"/> -->
          <i class="el-icon-video-play mengceng" v-show="item.mediatype == 2"/>
          <el-image :src="baseOssUrl+item.mediapath" fit="cover" style="width: 100px; height: 100px"
          @click="handleClickItem" :preview-src-list="[baseOssUrl+item.mediapath]"/>
        </li>
      </ul>
    </ul>
    <div style="padding-top:10px;text-align:center">
      <el-button @click="prizeCash = false">取 消</el-button>
      <el-button type="danger" @click="handleJxj()">确定</el-button>
    </div>
  </el-dialog>
  <div class="fullscreenMask" v-if="isShowImageDialog" @click="clearImg">
    <i class="el-icon-circle-close" style="position: absolute ;top: 50px;right: 50px;font-size: 30px;cursor: pointer;"/>
    <div style="width: 800px;margin: 200px 0 0 30%;">
      <el-carousel :autoplay = "false" height="500px">
        <el-carousel-item v-for="(item,index) in ShowImageDialogImgarr" :key="index" style="display: flex;align-items: center;justify-content: center;">
          <img :src="item" style="max-width: 100%; max-height: 100%;"/>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
  <el-dialog title='图片查看' :visible.sync="largeImage">
    <div class="imgDialog"> <img :src="showImageUrl"/> </div>
  </el-dialog>
  <!-- 视频预览 -->
  <el-dialog :visible.sync="videoVisible" @close="closeDialog" width="30%">
    <video-player ref="videoPlayer" class="video-player vjs-custom-skin" :playsinline="true" :options="playerOptions"/>
  </el-dialog>
  <!-- vueCropper 剪裁图片实现-->
  <el-dialog title="图片剪裁" :visible.sync="cropping" append-to-body center>
    <div class="cropper-content">
      <div class="cropper">
        <vueCropper ref="cropper" :img="option.img" :outputSize="option.size" :fixedBox="option.fixedBox"
        :outputType="option.outputType" :full="option.full" :canMove="option.canMove" :infoTrue="option.infoTrue"
        :canMoveBox="option.canMoveBox" :original="option.original" :autoCrop="option.autoCrop" :info="true"
        :fixed="option.fixed" :fixedNumber="option.fixedNumber" :centerBox="option.centerBox"
        :autoCropWidth="option.autoCropWidth" :autoCropHeight="option.autoCropHeight"/>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cropping = false">取 消</el-button>
      <el-button type="primary" @click="finish">确认</el-button>
    </div>
  </el-dialog>
</div>
</template>
<script>
import wjEditor from '../../components/MyWangEditor';
import { uploadOSS } from '../../utils/oss'; // oss上传
import { getOssFile, getfilterlist } from '../../api/newOss';
import { getSpecialOfferGoodsList, getSortedSpecialGoodsList, getRemoveSpecialOfferGoods, // 特价相关接口
  getSeckillGoodsList, getSortedSeckillGoodsList, getRemoveSeckillGoods, // 秒杀相关接口
  getGroupBuyGoodsList, getSortedGroupBuyGoodsList, getRemoveGroupBuyGoods, // 团购相关接口
  getlistcoupon, getSortedCouponList, getRemoveCoupon, getBatchUpdateCouponCommissionLimit, // 优惠券相关接口
  getReservationGoodsList, getSortedReservationGoodsList, getRemoveReservationGoods, // 预约签到礼相关接口
  getToStoreGiftList, delToStoreGift, getContinuityOrderList, delContinuityOrderGift, // 到店打卡礼&连单礼相关接口
  getCheckReservationGoodsIsAllowToInsert, specialpriceGetchoosegoods, specialpriceDelgoods, // 特价商品 相关接口
  smackerGetchoosegoods, smackerSavegoods, smackerDelgoods, smackerGoodssort, // 幸运购 相关接口
  xiaobiaotiList, addXiaobiaoti, infoXiaobiaoti, editXiaobiaoti, delXiaobiaoti, // 小标题 相关接口
  configtaskType,configSave, delPeizhi, activityformactivityType,
  activitytypesave, basesave, basegetinfo, configreset, signinverify, configsignin, activitytypegetinfo } from "../../api/activityFormList";
import addActiviteForm from "../../components/activity/addActiviteForm.vue";
  export default {
  name: "activityFormList",
  props:{
    whichRole:{
      type:Boolean,
      default:true
    }
  },
  components: { wjEditor,addActiviteForm, },
  data() {
    return {
      basicinfo: true, // 基本信息
      hdmc: "", // 活动名称
      hdTime: "", // 活动时间
      starthdTime: '', // 开始
      endhdTime: '', // 结束
      bannerImgUrl: "", // 活动banner
      BannerUrl: "", // 短
      fxfmImgUrl: '', // 分享封面
      ShareCoverImg: '', // 短
      // 控制活动时间不能小于当前时间
      pickerOptionsStart: {
        disabledDate(time) {
          return (
            time.getTime() < new Date(new Date().toLocaleDateString()).getTime()
          );
        },
      },
      timeInterval: [], // 时间区间集合
      ueditorValue: '', // 活动详情
      ActivityFormRelationDTOs: [], // 活动类型列表
      editActivityId: "", // 活动id
      // 活动形式侧边菜单
      isactive: 0,
      leftActivityFormList: [],
      activityId: 1, // 获取点击项id
      // 列表
      dataList: [],
      shangxian: "",
      isEdit: "",
      isToExamine: false, // 设置共创佣金上限-弹框
      upperLimit: "", // 上限
      upperLimitNew: "0",
      hdType: '', // 活动类型 1=平台活动 2=店铺 4=联盟活动
      yiyuan: false, // 幸运购-弹框
      yyqHdhm: '', // 幸运购-活动号码
      
      seeTksh: false, // 小标题弹框
      aiid: 0, // 活动图片主键
      shenmark: '', // 小标题input
      images: [], // 小标题多图

      // 引客到店奖现金
      seejlfsOne: '',
      rewardOne: 0, // 单份奖励
      shareOne: '', // 奖励份数
      rechargeAmountOne: 0, // 需充值金额
      
      // 创客分享奖现金
      seejlfsTwo: '',
      rewardTwo: 0, // 单份奖励
      wxrate: 0.006, // 微信手续费

      shareTwo: 0, // 奖励份数
      rechargeAmountTwo: 0, // 需充值金额
      
      prizeCash: false, // 引客到店奖现金 & 创客分享奖现金
      peizhiType: 3, // 配置类型
      jxjTitle: '引客到店奖现金', // 动态标题
      recharge: {
        totalprice: 0,
      },
      fxdpyq: 1, // 分享到朋友圈
      tasktyps: [],
      // 付费推广目的
      ykddjxj: [
        {name: '1.鼓励创客将本活动进行分享推广，引导客户进行线上报名，到线下参与活动；'},
        {name: '2.商家配置活动时，需配置签到礼品，创客推广活动时，引导客户进行线上报名；客户报名后获得签到礼品核销码；'},
        {name: '3.创客引导客户去活动现场进行核销礼品，客户进行签到礼品核销后，励直接发放给创客微信零钱。'},
      ],
      ckfxjxj: [
        {name: '1.鼓励创客将本活动进行分享，起到宣传活动的作用；'},
        {name: '2.创客按照分享要求进行分享，并按照要求截图上传给商家；'},
        {name: '3.商家对分享的有效性进行辨别审核，审核通过后奖励直接发放给创客。'},
      ],
      largeImage: false, // 图片查看
      showImageUrl: "",
      videoVisible: false, // 视频弹框
      playerOptions: {
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '4:3', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          src: "" // 视频url地址
        }],
        poster: '', // 你的封面地址
        width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true // 全屏按钮
        }
      },
      dpid: '', // 店铺id & 联盟id
      baseOssUrl: localStorage.BaseOssUrl,
      isShowImageDialog:false, // 查看大图弹框
      ShowImageDialogImgarr:[], // 大图预览
      activityTypeFrom: 0,
      
      zidingyiB: '', // 自定义纯展示
      zidingyiTitle: false, // 自定义标题-弹框
      activitiesName: '', // 自定义标题
      
      // 按行业选择
      checkAllone: true,
      isIndeterminateOne: false,
      formmenuOne: [], // 行业已选中
      industry: [], // 行业集合
      // 按品类选择
      checkAlltwo: true,
      isIndeterminateTwo: false,
      formmenuTwo:[], // 品类已选中
      mydata: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      category: [], // 品类集合
      cropping: false, // 图片裁剪弹框
      distinguish: '', // 区分两个上传图片
      // 裁剪组件的基础配置option
      option: {
        img: '', // 裁剪图片的地址
        info: false, // 裁剪框的大小信息
        outputSize: 0.8, // 裁剪生成图片的质量
        outputType: 'jpeg', // 裁剪生成图片的格式
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 1200, // 默认生成截图框宽度
        autoCropHeight: 675, // 默认生成截图框高度
        fixedBox: true, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [1200, 675], // 截图框的宽高比例
        full: false, // 是否输出原图比例的截图
        canMoveBox: false, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: true, // 截图框是否被限制在图片里面
        infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
      },
    };
  },
  watch: {
    // 单份奖励-1
    'rewardOne'(newV,oldV) {
      this.rechargeAmountOne = this.rewardOne * this.shareOne;
    },
    // 需充值金额-引客到店奖现金
    'shareOne'(newV,oldV) {
      // this.rechargeAmountOne = this.rewardOne * this.shareOne / (1 - this.wxrate);
      this.rechargeAmountOne = this.rewardOne * this.shareOne;
    },
    // 单份奖励-2
    'rewardTwo'(newV,oldV) {
      this.recharge.totalprice = this.rewardTwo * this.recharge.totalcount;
    },
    // 需充值金额-创客分享奖现金
    'recharge.totalcount'(newV,oldV) {
      // this.recharge.totalprice = this.rewardTwo * this.recharge.totalcount / (1 - this.wxrate);
      this.recharge.totalprice = this.rewardTwo * this.recharge.totalcount;
    },
  },
  methods: {
    initComponent(type,hdid,bbidlmid,sponsorType) {
      this.isEdit = type; // 新增 & 编辑 & 查看
      this.editActivityId = hdid; // 活动id
      this.dpid = bbidlmid; // 店铺id & 联盟id
      this.hdType = sponsorType; // 活动类型 1=平台活动 2=店铺 4=联盟活动
      localStorage.setItem('lianmengId',this.dpid);
      this.getactivitytypelist(); // 获取活动形式列表
      this.getfilterlist(); // 获取树列集合
      if(this.isEdit==1 || this.isEdit==2 || this.editActivityId){
        this.gethdinfo(); // 回显接口
        this.getPeizhi();
      }
    },
    // 点击活动形式
    handleCurrentChange(val,index) {
      this.isactive = index; // 把点击li的索引赋给 isactive
      this.activityId = val.id;
      this.zidingyiB = val.name;
      // let actid = val.$attrs['data-actid']  // 活动id
      // this.activityId = val ? formid : this.activityId;
      // let thiscustomname = this.leftActivityFormList[val.index].customname;
      // this.zidingyiB = thiscustomname?thiscustomname:val.name // 获取活动名称
      if(this.editActivityId){
        this.implementMethod(); // 查列表
        this.getCustomTitle(); // 获取自定义标题
        if(this.isEdit!=0){
          if(this.activityId!=10){
            this.getCustomTitle(); // 获取自定义标题
          }
        }
      }
    },
    // 获取活动形式详情
    getCustomTitle(){
      activitytypegetinfo('',this.editActivityId,this.activityId).then((data) => {
        this.zidingyiB = data.resultObj.customname;
      });
    },
    // 查询活动形式列表
    getactivitytypelist(){
      var obj = {
        shopId: this.dpid, // 店铺ID 当活动类型为3时，此字段必填
      };
      activityformactivityType(obj, this.hdType).then(data => {
        if (data.resultCode == 1) {
          this.leftActivityFormList = data.resultObj;
          this.leftActivityFormList.push({
            id: 10,
            name: "小标题",
          });
          this.activityId = this.leftActivityFormList[0].id; // 获取 活动id 第一个
          this.zidingyiB = this.leftActivityFormList[0].name; // 获取 活动名称 第一个
          if(this.editActivityId){
            this.implementMethod(); // 查询列表
            this.getCustomTitle(); // 获取自定义标题
          }
        }
        if (data.resultCode == 4) {
          this.leftActivityFormList = [];
        }
      });
    },
    implementMethod(){
      if(this.activityId == 1) {this.endSpecialOffer();} // 特价
      if(this.activityId == 2) {this.seckill();} // 秒杀
      if(this.activityId == 3) {this.groupBuying();} // 团购
      if(this.activityId == 4) {this.coupon();} // 优惠券
      if(this.activityId == 5) {this.appointmentCheck();} // 预约签到礼
      if(this.activityId == 6) {this.dddklList();} // 到店打卡礼
      if(this.activityId == 7) {this.dllList();} // 连单礼
      if(this.activityId == 8) {this.tjspList();} // 特价商品
      if(this.activityId == 9) {this.yyqList();} // 幸运购
      if(this.activityId == 10) {this.xbtList();} // 小标题
    },
    // 查询特价
    endSpecialOffer() {
      let addParams = {
        activityId: this.editActivityId, // 活动id
      };
      getSpecialOfferGoodsList(addParams).then((data) => {
        this.dataList = data.ResultObj;
      });
    },
    // 查询秒杀
    seckill() {
      let addParams = {
        activityId: this.editActivityId, // 活动id
      };
      getSeckillGoodsList(addParams).then((data) => {
        this.dataList = data.ResultObj;
      });
    },
    // 查询团购
    groupBuying() {
      let addParams = {
        activityId: this.editActivityId, // 活动id
      };
      getGroupBuyGoodsList(addParams).then((data) => {
        this.dataList = data.ResultObj;
      });
    },
    // 查询 优惠券
    coupon() {
      let addParams = {
        activityId: this.editActivityId, // 活动id
      };
      getlistcoupon(addParams).then((data) => {
        if (data.resultCode == 1) {
          
          // if(this.dataList) {
          //   this.shangxian = this.dataList[0].commissionCap;
          // }
          this.shangxian = data.RowsCount; // 获取回显优惠券佣金上限参数值
          
          this.dataList = data.resultObj;
        } else {
          this.dataList = [];
        }
      });
    },
    // 查询 预约签到礼
    appointmentCheck() {
      let addParams = {
        activityId: this.editActivityId, // 活动id
      };
      getReservationGoodsList(addParams).then(data => {
        if (data.ResultCode == 1) {
          this.dataList = data.ResultObj;
        } else {
          this.dataList = [];
        }
      });
    },
    // 查询 到店打卡礼
    dddklList() {
      let addParams = {
        activityId: this.editActivityId, // 活动id
      };
      getToStoreGiftList(addParams).then(data => {
        if(data) {
          if (data.resultCode == 1) {
            this.dataList = data.resultObj;
          } else {
            this.dataList = [];
          }
        } else {
          this.dataList = [];
        }
      });
    },
    // 查询 连单礼
    dllList() {
      let addParams = {
        activityId: this.editActivityId, // 活动id
      };
      getContinuityOrderList(addParams).then(data => {
        if(data) {
          if (data.resultCode == 1) {
            this.dataList = data.resultObj;
          } else {
            this.dataList = [];
          }
        } else {
          this.dataList = [];
        }
      });
    },
    // 查询 特价商品
    tjspList() {
      let addParams = {
        activityId: this.editActivityId, // 活动id
      };
      specialpriceGetchoosegoods(addParams).then(data => {
        if(data) {
          if (data.resultCode == 1) {
            this.dataList = data.resultObj.list;
          } else {
            this.dataList = [];
          }
        } else {
          this.dataList = [];
        }
      });
    },
    // 查询 幸运购
    yyqList() {
      let addParams = {
        activityId: this.editActivityId, // 活动id
      };
      smackerGetchoosegoods(addParams).then(data => {
        if(data) {
          if (data.resultCode == 1) {
            this.dataList = data.resultObj.list;
          } else {
            this.dataList = [];
          }
        } else {
          this.dataList = [];
        }
      });
    },
    // 查询 小标题
    xbtList() {
      let addParams = {
        activityid: this.editActivityId, // 活动id
        pageindex: 1,
        pagesize: 10,
        imgtype: 1 // 图片类型1=参展品牌 2=特价商品海报 不传默认1
      };
      xiaobiaotiList(addParams).then(data => {
        if(data){
          if (data.resultCode == 1) {
            this.dataList = data.resultObj.list;
            // this.totalcount = data.resultObj.totalcount; // 总数
          }else {
            this.dataList = [];
          }
        }else {
          this.dataList = [];
        }
      });
    },
    // 幸运购-保存
    yyqSubmit() {
      let obj = {
        activityId: this.editActivityId, // 活动id
        smackerCode: this.yyqHdhm, // 活动号码
        operatorId: localStorage.Id, // 操作人id
      };
      smackerSavegoods(obj).then(data => {
        if (data.resultCode == 1) {
          this.$swal({
            type: "success",
            // text: "添加成功",
            text: data.resultMsg,
          });
          this.yiyuan = false;
          this.yyqHdhm = '';
          this.yyqList(); // 刷新幸运购列表
        }
      });
    },
    // 新增
    addRelatedBrand() {
      this.isFormEditOrAdd=0;
      // editActivityId 活动id
      // activityId 活动形式id
      this.addedit(1); // 临时保存
    },
    // 编辑
    handleActivity(row) {
      let soId = row.id;
      this.isFormEditOrAdd = 1;
      if(this.activityId == 10){
        this.seeTksh = true; // 弹框
        this.aiid = row.aiid; // 活动图片主键
        infoXiaobiaoti('', this.aiid).then(data => {
          if (data.resultCode == 1) {
            this.shenmark = data.resultObj.title; // 小标题
            this.images = data.resultObj.images.map(item => item.replace('', localStorage.BaseOssUrl)); // 图片集合
            // this.images = data.resultObj.imageurl.split(',').map(item => item.replace('', localStorage.BaseOssUrl)); // 图片集合
          }
        });
      }else{
        this.basicinfo = false;
        this.showWhichAddActiveForm(this.editActivityId,this.activityId,soId,this.hdType);
      }
    },
    // 查看
    seeinfo(row, type) {
      let soId = row.id;
      this.isFormEditOrAdd = 1;
      this.basicinfo = false;
      this.showWhichAddActiveForm(this.editActivityId,this.activityId,soId,this.hdType, type);
    },
    // 接收第三部详情页数据
    newlyAdded() {
      this.addActive = 2; // 活动形式页面
      this.activityTypeFrom = 0;
      this.basicinfo = true;
      this.implementMethod(); // 查询列表
    },
    // 展示第三步中的新增活动表单
    showWhichAddActiveForm(editActivityId,activityTypeFrom,soId,sponsorType,see) {
      this.basicinfo = false;
      this.editActivityId = editActivityId; // 活动id
      this.activityTypeFrom = activityTypeFrom; //新增的活动形式类型（1 特价 2 秒杀  3 团购 4 优惠券  5 签到礼）
      this.$set(this,"activityTypeFrom",activityTypeFrom);
       this.$nextTick(() => {
        this.$refs.addActiviteForm.initComponent(this.editActivityId,this.activityTypeFrom,soId,sponsorType,see);
      });
    },
    // 上一步===> 由新增活动表单返回到活动形式
    cancelActiveForm(whichStep,activityTypeFrom,sponsorType) {
      this.basicinfo = true;
      this.addActive = whichStep;
      this.activityTypeFrom = activityTypeFrom; // 活动形式id
      this.$set(this,"activityTypeFrom",0);
      this.implementMethod(); // 查询列表
      // this.$nextTick(() => {
      //   this.$refs[this.refsList[whichStep].name].initComponent(this.editActivityId,this.isEditOrAddOrSee,this.activeListData,'',this.activityTypeFrom, sponsorType);
      // });
      
    },
    // 操作向上 & 向下
    spUpordown(row, val) {
      // 特价-排序
      if(this.activityId == 1) {
        let sortVariable = {
          activityId: this.editActivityId, // 活动id
          specialOfferGoodsId: row.id, // 特价商品列表id！！！！
          direction: val, // 操作类型；1：向上、2：向下
        };
        getSortedSpecialGoodsList(sortVariable).then((data) => {
          if (data.ResultCode == 1) {
            this.endSpecialOffer();
          }
        });
      }
      // 秒杀-排序
      if(this.activityId == 2) {
        let sortVariable = {
          activityId: this.editActivityId, // 活动id
          goodsId: row.id, // 秒杀商品主键id
          direction: val, // 1=向上；2=向下
        };
        getSortedSeckillGoodsList(sortVariable).then((data) => {
          if (data.ResultCode == 1) {
            this.seckill();
          }
        });
      }
      // 团购-排序
      if(this.activityId == 3) {
        let sortVariable = {
          activityId: this.editActivityId, // 活动id
          goodsId: row.id, // 团购商品主键id
          direction: val, // 1=向上；2=向下
        };
        getSortedGroupBuyGoodsList(sortVariable).then((data) => {
          if (data.ResultCode == 1) {
            this.groupBuying();
          }
        });
      }
      // 优惠券-排序
      if(this.activityId == 4) {
        let sortVariable = {
          activityId: this.editActivityId, // 活动id
          couponId: row.id, // 活动优惠券主键id
          direction: val, // 1=向上;2=向下
        };
        getSortedCouponList(sortVariable).then((data) => {
          if (data.ResultCode == 1) {
            this.coupon();
          }
        });
      }
      // 预约签到礼-排序
      if(this.activityId == 5) {
        let sortVariable = {
          activityId: this.editActivityId, // 活动id
          goodsId: row.id, // 预约礼商品主键id
          direction: val, // 1=向上;2=向下
        };
        getSortedReservationGoodsList(sortVariable).then((data) => {
          if (data.ResultCode == 1) {
            this.appointmentCheck();
          }
        });
      }
      // 幸运购-排序
      if(this.activityId == 9) {
        let sortVariable = {
          activityId: this.editActivityId, // 活动id
          sort: row.sort, // 排序值
          sortType: val, // 排序类型 1=上移 2=下移
          operatorId: localStorage.Id, // 操作人id
        };
        smackerGoodssort(sortVariable).then((data) => {
          if (data.ResultCode == 1) {
            this.yyqList();
          }
        });
      }
    },
    // 单条删除-列表数据
    deleteBrand(row) {
      this.$swal({
        type: "warning",
        text: "重要信息，你确定要删除吗？",
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      }).then((res) => {
        if (res.value) {
          // 特价 - 删除
          if(this.activityId == 1) {
            let deleteVariable = {
              specialOfferGoodsId: row.id,
            };
            getRemoveSpecialOfferGoods(deleteVariable).then((data) => {
              if (data.ResultCode == 1) {
                this.$swal({
                  type: "success",
                  text: "特价-删除 操作成功",
                });
                this.endSpecialOffer();
              }
            });
          }
          // 秒杀 - 删除
          if(this.activityId == 2) {
            let deleteVariable = {
              goodsId: row.id,
            };
            getRemoveSeckillGoods(deleteVariable).then((data) => {
              if (data.ResultCode == 1) {
                this.$swal({
                  type: "success",
                  text: "秒杀-删除 操作成功",
                });
                this.seckill();
              }
            });
          }
          // 团购 - 删除
          if(this.activityId == 3) {
            let deleteVariable = {
              goodsId: row.id,
            };
            getRemoveGroupBuyGoods(deleteVariable).then((data) => {
              if (data.ResultCode == 1) {
                this.$swal({
                  type: "success",
                  text: "团购-删除 操作成功",
                });
                this.groupBuying();
              }
            });
          }
          // 优惠券 - 删除
          if(this.activityId == 4) {
            let deleteVariable = {
              activityCouponId: row.id,
            };
            getRemoveCoupon(deleteVariable).then((data) => {
              if (data.ResultCode == 1) {
                this.$swal({
                  type: "success",
                  text: "优惠券-删除 操作成功",
                });
                this.coupon();
              }
            });
          }
          // 预约签到礼 - 删除
          if(this.activityId == 5) {
            let deleteVariable = {
              goodsId: row.id,
            };
            getRemoveReservationGoods(deleteVariable).then((data) => {
              if (data.ResultCode == 1) {
                this.$swal({
                  type: "success",
                  text: "预约签到礼-删除 操作成功",
                });
                this.appointmentCheck();
              }
            });
          }
          // 到店打卡礼 - 删除
          if(this.activityId == 6) {
            delToStoreGift('', row.id).then(data => {
              if (data.resultCode == 1) {
                this.$swal({
                  type: "success",
                  text: "到店打卡礼-删除 操作成功",
                });
                this.dddklList();
              }
            });
          }
          // 连单礼 - 删除
          if(this.activityId == 7) {
            delContinuityOrderGift('', row.id).then(data => {
              if (data.resultCode == 1) {
                this.$swal({
                  type: "success",
                  text: "连单礼-删除 操作成功",
                });
                this.dllList();
              }
            });
          }
          // 特价商品 - 删除
          if(this.activityId == 8) {
            let obj = {
              activityId: this.editActivityId, // 活动id
              shopId: row.shopid, // 店铺ID
              goodsIds: row.goodsid, // 店铺商品ID，多个商品用英文逗号隔开
              operatorId: localStorage.Id, // 操作人id
            }
            specialpriceDelgoods(obj, row.id).then(data => {
              if (data.resultCode == 1) {
                this.$swal({
                  type: "success",
                  text: "特价商品-删除 操作成功",
                });
                this.tjspList();
              }
            });
          }
          // 幸运购 - 删除
          if(this.activityId == 9) {
            let obj = {
              activityId: this.editActivityId, // 活动id
              asgId: row.asgid, // 幸运购活动商品主键
              operatorId: localStorage.Id, // 操作人id
            }
            smackerDelgoods(obj, row.id).then(data => {
              if (data.resultCode == 1) {
                this.$swal({
                  type: "success",
                  text: "幸运购-删除 操作成功",
                });
                this.yyqList();
              }
            });
          }
          // 小标题 - 删除
          if(this.activityId == 10) {
            let obj = {
              aiid: row.aiid, // 活动图片主键
            }
            delXiaobiaoti(obj).then(data => {
              if (data.resultCode == 1) {
                this.$swal({
                  type: "success",
                  text: "小标题-删除 操作成功",
                });
                this.xbtList();
              }
            });
          }
        }
      });
    },
    // 设置共创
    endSetUp() {
      this.isToExamine = true;
      this.upperLimit = "";
    },
    // 保存按钮
    editSubmit() {
      if(this.upperLimit == ""){
        this.$swal({
          type:'warning',
          text: '请输入上限值',
        })
        return false;
      }
      var loginParams = {
        activityId: this.editActivityId, // 活动id
        commissionCap: this.upperLimit, // 佣金上限,取值范围:0-9999999
      };
      getBatchUpdateCouponCommissionLimit(loginParams).then(data => {
        if (data.ResultCode == 1) {
          this.$swal({
            text: "修改成功",
            type: "success"
          })
          this.upperLimitNew = data.ResultObj;
        } else if(data.ResultCode == 4) {
          this.$swal({
            text: "无数据",
            type: "warning"
          })
          this.upperLimitNew = data.ResultObj;
        } else {
          this.$swal({
            text: data.ResultMsg,
            type: "warning"
          })
        }
        this.isToExamine = false;
        this.coupon();
      })
    },
    // 返回
    resetForm() {
      this.$emit('cancleAddBaseMsg')
    },
    // 新增 & 修改
    addedit(val){
      if (!this.hdmc) {
        this.$swal({
          type: "warning",
          text: "请输入活动名称",
        });
        return false;
      }
      if (this.hdmc.length < 5) {
        this.$swal({
          type: "warning",
          text: "活动名称最少5个字",
        });
        return false;
      }
      if (!this.hdTime) {
        this.$swal({
          type: "warning",
          text: "请选择活动时间",
        });
        return false;
      }
      // if (!this.ActivityFormRelationDTOs.length) {
      //   this.$swal({
      //     type: "warning",
      //     text: "请添加活动类型",
      //   });
      //   return false;
      // }
      if (!this.bannerImgUrl) {
        this.$swal({
          type: "warning",
          text: "请上传活动活动主图",
        });
        return false;
      }
      if(!this.fxfmImgUrl) {
        this.$swal({
          type: "warning",
          text: "请上传分享封面",
        });
        return false;
      }
      if(val == 0 && !this.ueditorValue){
        this.$swal({
          type: "warning",
          text: "请输入活动详情",
        });
        return false;
      }
      setTimeout(()=>{
      let params={
        title: this.hdmc, // 活动名称
        bdate: this.starthdTime, // 活动开始日期 格式：yyyy-MM-dd
        edate: this.endhdTime, // 活动结束日期 格式：yyyy-MM-dd
        bannerimg: this.BannerUrl, // 活动主图路径(相对路径)
        sharecoverimg: this.ShareCoverImg, // 分享封面 （相对路径）
        explain: this.ueditorValue, // 活动详情
        sponsortype: this.hdType, // 活动类型 1=平台活动 2=店铺 4=联盟活动
        shopid: this.dpid?Number(this.dpid):0, // 店铺ID( 说明：1、平台活动店铺ID传0 2、如果是联盟活动，则传联盟ID）
        operatorid: Number(localStorage.Id), // 操作人ID
        activityid: this.editActivityId?this.editActivityId:0, // 活动ID 未0则表示是新增操作
        istemp: val, // 是否是临时保存 0=否 1=是
      }
      basesave(params).then(data => {
        if (data.resultCode == 1) {
          this.editActivityId = data.resultObj; // 获取活动id
          if(val==0){
            this.$swal({
              text:"操作成功",
              type:"success"
            })
            this.$emit('cancleAddBaseMsg');
          }else{
            if(val==1){
              // 是否允许创建
              if(this.activityId == 5) {
                let addParams = {
                  activityId: this.editActivityId, // 活动id
                };
                getCheckReservationGoodsIsAllowToInsert(addParams).then((data) => {
                  // 允许创建
                  if (data.ResultCode == 1) {
                    this.basicinfo = false;
                    this.showWhichAddActiveForm(this.editActivityId, this.activityId,0, this.hdType);
                  } else {
                    // 不允许创建
                    this.$swal({
                      type: "warning",
                      text: data.ResultMsg,
                    });
                  }
                });
              }else if(this.activityId == 9){ // 幸运购-新增
                this.yiyuan = true; // 幸运购弹框
                this.yyqHdhm = '';
              }else if(this.activityId == 10){ // 小标题-新增
                this.seeTksh = true; // 小标题弹框
                this.aiid = 0; // 新增做清空操作
                this.shenmark = '';
                this.images = [];
              }else{
                this.basicinfo = false;
                this.showWhichAddActiveForm(this.editActivityId, this.activityId,0, this.hdType);
              }
            }
            if(val == 2){
              this.zidingyiTitle=true;
              this.activitiesName=this.zidingyiB;
            }
            if(val == 3){
              if(this.editActivityId){
              this.getPeizhi();
              this.jxjTitle = '创客分享奖现金';
              this.prizeCash = true;
              this.isIndeterminateOne = false;
              this.isIndeterminateTwo = false;
              }
            }
          }
        }
      });
      },300)
    },
    // 小标题-确定
    qdTksh() {
      if(this.shenmark == "") {
        this.$swal({
          type: "warning",
          text: "请输入小标题"
        }); return false;
      }
      if(this.images.length===0) {
        this.$swal({
          type:"warning",
          text: '请至少上传一张标题的图片'
        })
        return false;
      }
      let addParams = {
        operatorid: Number(localStorage.Id), // 操作人id
        activityid: this.editActivityId, // 活动ID
        aiid: this.aiid, // 活动图片主键
        remark: this.shenmark, // 小标题
        url: this.images.map(item => item.replace(localStorage.BaseOssUrl, '')).join(","), // 图片路径 （相对路径）
        imgtype: 1, // 图片类型1=参展品牌（小标题） 2=特价商品海报 默认1
      };
      let thisApi = this.aiid==0?addXiaobiaoti:editXiaobiaoti;
      thisApi(addParams).then(data => {
        if (data.resultCode == 1) {
          this.$swal({
            text:"操作成功",
            type:"success"
          })
          this.xbtList();
          this.seeTksh = false;
        } else {
          this.$swal({
            type: "warning",
            text: data.resultMsg,
          });
        }
      })
    },
    // 活动Banner & 分享封面
    beforeAvatarUpload(file, type) {
      this.distinguish = type; // 区分
      if(type == 1){
        this.option.autoCropWidth = 1200;
        this.option.autoCropHeight = 675;
        this.option.fixedNumber = [1200, 675];
      }
      if(type == 2){
        this.option.autoCropWidth = 1000;
        this.option.autoCropHeight = 800;
        this.option.fixedNumber = [1000, 800];
      }
      const isSize = new Promise(function (resolve, reject) {
        let width = type == 1 ? 1200 : 1000;
        let height = type == 1 ? 675 : 800;
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function () {
          let valid = img.width == width && img.height == height;
          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
      })
      isSize.then(() => {
        var that = this;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = async function (e) {
          that.handleOss(11); // oss 直传图片
          var newOssPic = await uploadOSS(file,0);
          if(type == 1) {
            that.bannerImgUrl = newOssPic;
            that.BannerUrl = newOssPic.replace(localStorage.BaseOssUrl,'')
          }
          if(type == 2) {
            that.fxfmImgUrl = newOssPic;
            that.ShareCoverImg = newOssPic.replace(localStorage.BaseOssUrl,'')
          }
          that.cropping = false; // 图片裁剪弹框
        };
      },() => {
        var that = this;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function(e) {
          // 上传成功后将图片地址赋值给裁剪框显示图片
          that.$nextTick(() => {
            that.option.img = e.target.result
            that.cropping = true; // 图片裁剪弹框
            if(type == 1) {
              setTimeout(()=>{
                // document.querySelector('.crop-info').setHTML("1200 x 675")
                document.querySelector('.crop-info').innerHTML = '1200 x 675'
              },300)
            }
            if(type == 2) {
              setTimeout(()=>{
                // document.querySelector('.crop-info').setHTML("1000 x 800")
                document.querySelector('.crop-info').innerHTML = '1000 x 800'
              },300)
            }
          })
          return
        };
        // this.$swal({
        //   type: "warning",
        //   text: type == 1?"上传图片宽高应为1200*675":"上传图片宽高应为1000*800",
        // });
      });
    },
    // 点击裁剪，这一步是可以拿到处理后的地址
    finish() {
      let that = this
      this.$refs.cropper.getCropBlob(data => {
        var canvas=document.getElementById("canvasa");
        var ctx=canvas.getContext("2d");
        let _URL = window.URL || window.webkitURL;
        var img=new Image();
        img.onload=start;
        img.src=_URL.createObjectURL(data);
        function start(){
          canvas.width=that.distinguish==1?1200:1000;
          canvas.height=that.distinguish==1?675:800;
          var w=img.width;
          var h=img.height;
          var sizer=Math.min((canvas.width/w),(canvas.height/h));
          ctx.drawImage(img,0,0,w,h,0,0,w*sizer,h*sizer);
          var dataURL = canvas.toDataURL('image/png');
          var getRes = dataURL;//读取的结果在result中
          function dataURLtoFile(dataurl, filename) {
            var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
            while(n--){
              u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, {type:mime});
          }
          var file = dataURLtoFile(getRes)
          that.beforeAvatarUpload(file, that.distinguish)
        }
      })
    },
    // 活动时间转换
    changeActiveTime(time) {
      this.starthdTime = time[0];
      this.endhdTime = time[1];
      
      let arr = []
      let str_b = time[0].split('-')
      let str_e = time[1].split('-')
      let date_b = new Date()
      date_b.setUTCFullYear(str_b[0], str_b[1] - 1, str_b[2])
      let date_e = new Date()
      date_e.setUTCFullYear(str_e[0], str_e[1] - 1, str_e[2])
      let unixDb = date_b.getTime() - 24 * 60 * 60 * 1000
      let unixDe = date_e.getTime() - 24 * 60 * 60 * 1000
      for (let j = unixDb; j <= unixDe;) {
        j = j + 24 * 60 * 60 * 1000
        arr.push(this.timestampToTime(new Date(parseInt(j))))
      }
      console.log(arr);
      this.timeInterval = arr; // 时间区间集合
      // this.$cookie.set("timeInterval", this.timeInterval); // 时间段集合 存入cookie
      localStorage.setItem('timeInterval',JSON.stringify(this.timeInterval));
    },
    // 获取时间段函数
    // timestampToTime (date) {
    //   var Y = date.getFullYear() + '-';
    //   var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    //   var D = (date.getDate() + 1 < 10 ? '0' + (date.getDate() + 1) : date.getDate() + 1);
    //   return Y + M + D;
    // },
    timestampToTime (date) {
      var Y = date.getFullYear() + '-';
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var D = date.getDate();
      return Y + M + D;
    },
    
    // 多图上传
    multiGraphUpload(file) {
      // 判断图片格式
      const isJPG = file.type === 'image/png' || file.type === 'image/jpg' ||file.type === 'image/jpeg';
      // 判断图片大小
      const isLt2M = file.size / 1024 / 1024 <= 5;
      if (!isJPG) {
        this.$swal({
          type: "warning",
          text: "上传图片只支持jpg、png等格式!"
        }); return;
      }
      if (!isLt2M) {
        this.$swal({
          type: "warning",
          text: "上传图片大小不能超过 5MB!"
        }); return;
      }
      if (this.images.length <= 10) {} else {
        this.$swal({
          type: "warning",
          text: "最多传入10张图片"
        });
        return false;
      }
      var _this = this;
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = async function(e) {
        _this.handleOss(11); // oss 直传图片
        var newOssPic = await uploadOSS(file,0);
        _this.images.push(newOssPic);
      };
      return file;
    },
    // 删除上传图片
    deldetail(index) {this.images.splice(index, 1)},
    // 活动详情-富文本
    contentChangeOne(content) {this.ueditorValue = content;},
    // 获取 行业 & 品类
    getfilterlist(){
      getfilterlist('').then(data => {
        if (data.resultCode == 1) {
          this.industry = data.resultObj.industry; // 行业集合
          this.category = data.resultObj.category; // 品类集合
        }
      })
    },
    getTreeselect() {
      this.$refs.tree.setCheckedKeys(this.formmenuTwo);  //通过 keys 设置目前勾选的节点，使用此方法必须设置 node-key 属性
      // this.mydata = this.convertTreeData(this.category);//因为下面要判断数组长度，树的结构里包含children，所以要将其展开。
      //与全选关联起来，判断是否全部选中还是部分选中
      let checkedCount = this.formmenuTwo.length;
      this.checkAlltwo = checkedCount === this.category.length;
      this.isIndeterminateTwo = checkedCount > 0 && checkedCount < this.category.length;
    },
    // tree 结构转化成一维数组
    convertTreeData(menuOptions) {
      for (let i = 0; i < menuOptions.length; i++) {
        if (menuOptions[i].children != undefined) {
          const temp = menuOptions[i].children;
          delete menuOptions[i].children;
          menuOptions = menuOptions.concat(temp);
        }
      }
      return menuOptions;
    },
    handleCheckedCities(value) {
      let checkedCount = value.length;
      this.checkAllone = checkedCount === this.industry.length;
      this.isIndeterminateOne = checkedCount > 0 && checkedCount < this.industry.length;
    },
    // 全选 / 全不选
    handleCheckAllChange(val,type) {
      if(type==1){
        // this.checkAllone = val;
        // if (this.checkAllone) {
        //   this.$refs.tree.setCheckedNodes(this.industry);
        // } else {
        //   this.$refs.tree.setCheckedKeys([]);
        // }
        const all = this.industry.map(item => {
          return item.id
        })
        this.formmenuOne = val ? all : [];
        this.isIndeterminateOne = false;
      }
      if(type==2){
        this.checkAlltwo = val;
        if (this.checkAlltwo) {
          this.$refs.tree.setCheckedNodes(this.category);
        } else {
          this.$refs.tree.setCheckedKeys([]);
        }
        this.isIndeterminateTwo = false;
      }
    },
    // 重置
    chongzhiPz(valType) {
      if(valType==1){ // 引客到店
        let params = {
          activityid: this.editActivityId, // 活动ID
        };
        configreset(params).then(data => {
          if (data.resultCode == 1) {
            this.$swal({
              type: "success",
              text: "操作成功",
            });
            this.seejlfsOne = '';
          }
        });
      }else {
        let params = {
          tasktype: 2, // 类型 1=分享赚钱-店铺充值 2=分享赚钱-活动充值  5=分享赚钱-幸运购
          shopid: this.dpid?this.dpid:0, // 店铺ID
          activityid: this.editActivityId, // 活动ID
        };
        delPeizhi(params).then(data => {
          if (data.resultCode == 1) {
            this.$swal({
              type: "success",
              text: "操作成功",
            });
            this.seejlfsTwo = '';
          }
        });
      }
    },
    // 配置
    configuration(valType) {
      this.peizhiType = valType;
      // valType 配置类型
      // 1=付费推广-店铺
      // 2-创客分享奖现金-店铺活动&联盟活动
      // 3=引客到店-店铺活动&联盟活动
      // 5=创客分享奖现金-幸运购
      if(this.editActivityId){
        if(this.rewardOne<=0&&this.shareOne<=0){
          this.getPeizhi();
        }
      }
      if(this.peizhiType == 2){
        this.addedit(3);
      }
      if(this.peizhiType == 3){
        if(this.editActivityId){
          let params={
            shopid: this.hdType==4?0:this.dpid, // 店铺ID
            activityid: this.editActivityId, // 活动ID
            lmid: this.hdType==4?this.dpid:0,
          }
          configtaskType(params, this.peizhiType).then(data => {
            if (data.resultCode == 1) {
              this.rewardOne = this.rewardOne>0?this.rewardOne:data.resultObj.univalence; // 单价 单位：元
              let obj = {
                activityid: this.editActivityId
              }
              signinverify(obj).then(data => {
                if(data){
                  if (data.resultCode == 1) {
                    this.jxjTitle = '引客到店奖现金';
                    this.prizeCash = true;
                  }else{
                    this.$swal({
                      text: data.resultMsg,
                      type: 'warning'
                    })
                  }
                } else{
                  this.$swal({
                    text: '签到礼品未配置或礼品数量配置有误',
                    type: 'warning'
                  })
                }
              })
            }
          })
        }else{
          this.addedit(3);
        }
        
      }
    },
    // 获取活动基本信息
    gethdinfo(){
      basegetinfo('', this.editActivityId).then(data => {
        if (data.resultCode == 1) {
          let thisData = data.resultObj;
          this.hdmc = thisData.title; // 活动名称
          this.hdTime = [thisData.starttime,thisData.endtime]; // 活动日期
          this.starthdTime = thisData.starttime; // 开始
          this.endhdTime = thisData.endtime; // 结束
          this.changeActiveTime(this.hdTime);
          this.bannerImgUrl = localStorage.BaseOssUrl + thisData.bannerurl; // 活动主图
          this.BannerUrl = thisData.bannerurl; // 短
          this.fxfmImgUrl = localStorage.BaseOssUrl + thisData.sharecoverimg; // 分享封面
          this.ShareCoverImg = thisData.sharecoverimg; // 短
          this.ueditorValue = thisData.activityexplain; // 活动详情
          
          this.rewardOne = thisData.rewardamount; // 单份奖励
          this.shareOne = thisData.rewardamountcount; // 奖励份数
          this.seejlfsOne = thisData.rewardamountcount; // 奖励份数
          this.rechargeAmountOne = thisData.totalprice; // 需充值金额
        }
      });
    },
    // 创客分享奖现金
    getPeizhi() {
      let params={
        shopid: this.hdType==4?0:this.dpid, // 店铺ID
        activityid: this.editActivityId, // 活动ID
        lmid: this.hdType==4?this.dpid:0,
      }
      configtaskType(params, 2).then(data => {
        if (data.resultCode == 1) {
          this.tasktyps = data.resultObj.tasktyps?data.resultObj.tasktyps:[]; // 任务类型集合
          this.recharge = data.resultObj.recharge; // 配置记录(充值单记录)
          this.fxdpyq = this.recharge.bttids?this.recharge.bttids[0]:this.tasktyps[0].bttid;
          this.rewardTwo = data.resultObj.univalence; // 单价 单位：元
          this.seejlfsTwo = data.resultObj.recharge.totalcount; // 赋值份数
          this.wxrate = data.resultObj.wxrate; // 微信手续费 默认0.006
          
          let hy = data.resultObj.filters.industry; // 行业ID集合
          if(hy[0]==0){
            this.formmenuOne = this.industry.map(item =>item.id); // 处理为全部选中状态
          }else {
            this.formmenuOne = hy;
            hy.length==5?this.isIndeterminateOne = false:this.isIndeterminateOne = true;
          }
          let pl = data.resultObj.filters.category; // 品类ID集合
          if(pl[0]==0){
            this.$refs.tree.setCheckedNodes(this.category); // 处理为全部选中状态
          }else{
            this.$refs.tree.setCheckedKeys(pl);
            this.isIndeterminateTwo = true;
          }
          
        }
      })
    },
    // 确定配置
    handleJxj() {
      if(this.peizhiType == 3){ // 引客到店奖现金
        if (!this.shareOne || this.shareOne<=0) {
          this.$swal({
            type: "warning",
            text: "请输入大于0的份数",
          });
          return false;
        }
        let params={
          activityid: this.editActivityId, // 活动ID
          univalence: this.rewardOne, // 单价 单位：元
          count: Number(this.shareOne), // 数量
        }
        configsignin(params).then(data => {
          if (data.resultCode == 1) {
            this.$swal({
              text:"配置成功",
              type:"success"
            })
            this.prizeCash = false; // 配置
            this.seejlfsOne = this.shareOne; // 赋值奖励份数
          }
        })
      }else{ // 创客分享奖现金
        if (!this.recharge.totalcount || this.recharge.totalcount<=0) {
          this.$swal({
            type: "warning",
            text: "请输入大于0的份数",
          });
          return false;
        }
        let plarr=this.$refs.tree.getCheckedKeys(this.formmenuTwo).concat(this.$refs.tree.getHalfCheckedKeys());
        let params={
          tasktype: 2, // 类型 1=分享赚钱-店铺充值 2=分享赚钱-活动充值  5=分享赚钱-幸运购
          price: Number(this.rewardTwo), // 单份奖励
          num: Number(this.recharge.totalcount), // 份额
          remark: this.recharge.remark, // 分享文案(备注)
          shopid: this.dpid, // 店铺ID
          activityid: this.editActivityId, // 活动ID
          operatorid: Number(localStorage.Id), // 操作人id
          begintime: this.starthdTime, // 有效期-开始 格式：yyyy-MM-dd
          endtime: this.endhdTime, // 有效期-结束 格式：yyyy-MM-dd
          // bttids: this.fxdpyq==true?'1':[], // 任务类型ID 多个用英文逗号隔开
          bttids: this.fxdpyq, // 任务类型ID 多个用英文逗号隔开
          industry: this.formmenuOne, // 创客行业ID集合
          category: plarr, // 员工创客所属店铺品类ID集合
        }
        configSave(params).then(data => {
          if (data.resultCode == 1) {
            this.$swal({
              text:"配置成功",
              type:"success"
            })
            this.prizeCash = false; // 配置
            this.seejlfsTwo = this.recharge.totalcount; // 赋值奖励份数
          }
        })
      }
    },
    // 查看大图
    handleplay(itemI) { // 媒体素材类型 1=图片 2=视频
      if(itemI.mediatype ==1) {
        this.largeImage = true;
        this.showImageUrl = localStorage.BaseOssUrl + itemI.videoimg;
      }
      if(itemI.mediatype ==2) {
        this.palySeevideo(localStorage.BaseOssUrl + itemI.mediapath);
      }
    },
    // 播放视频
    palySeevideo(url){
      this.videoVisible = true;
      this.playerOptions.sources[0].src = url;
    },
    closeDialog() {
      this.$refs.videoPlayer.player.pause();
    },
    // 预览
    seebigimg(row){
      infoXiaobiaoti('', row.aiid).then(data => {
        if (data.resultCode == 1) {
          this.isShowImageDialog = true;
          this.ShowImageDialogImgarr = data.resultObj.images.map(item => item.replace('', localStorage.BaseOssUrl)); // 图片集合
        }
      });
    },
    // 关闭查看大图
    clearImg(){
      this.isShowImageDialog = false;
    },
    // 配置标题
    configuretitle(){
      this.addedit(2); // 临时保存
    },
    // 自定义标题-确定
    complete(){
      if(this.activitiesName == "") {
        this.$swal({
          type: "warning",
          text: "请输入自定义标题"
        }); return false;
      }
      let params = {
        activityid: this.editActivityId, // 活动ID 未0则表示是新增操作
        typeid: this.activityId, // 活动形式ID
        typename: this.activitiesName, // 自定义标题
      };
      activitytypesave(params).then(data => {
        if (data.resultCode == 1) {
          this.$swal({
            type: "success",
            text: "操作成功",
          });
          this.zidingyiTitle=false;
          this.zidingyiB=this.activitiesName; // 赋值文案
          this.leftActivityFormList.forEach(item => item.id===this.activityId?item.customname = this.zidingyiB:item.name);
        }
      });
    },
    // 获取描述
    get_description(type){
      let pyq = []
      let wxq = []
      let all = this.tasktyps.find(i=>i.bttid==this.fxdpyq).descriptions.map(i=>{
        if(i.sort/10<1){
          pyq.push(i.taskdesc)
        }else{
          wxq.push(i.taskdesc)
        }
      })
      if (type=='pyq'){
        return pyq
      }else{
        return wxq
      }
    },
    // 关闭el-image遮罩层
    handleClickItem() {
      this.$nextTick(() => {
        // 获取遮罩层dom
        let domImageMask = document.querySelector('.el-image-viewer__mask')
        if (!domImageMask) {
          return
        }
        domImageMask.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },
    /* oss 直传图片 */
    handleOss(val){
      let obj = { type: val };
      getOssFile(obj).then(data => {
        if (data.resultCode == 1) {
          let ossId = data.resultObj.accesskeyid; // 登录RAM账户id
          let ossSecret = data.resultObj.accesskeysecret; // 登录RAM账户密码
          let ossHost = data.resultObj.hostendpoint; // 请求的OSS服务端点
          let ossfile = data.resultObj.directory; // 保存路径
          let ossbucket = data.resultObj.bucket; // bucket
          localStorage.setItem('keyossId',ossId);
          localStorage.setItem('keyossSecret',ossSecret);
          localStorage.setItem('keyossHost',ossHost);
          localStorage.setItem('keyossfile',ossfile);
          localStorage.setItem('keyossbucket',ossbucket);
        }
      })
    },

  },
};
</script>
<style scoped>
/* 活动主图&分享封面 */
.uploadActiveForm{
  margin-bottom: 0;
}
.activityFormClass {
  /* height: calc(100vh - 150px); */
  /* height: calc(500px - 1px); */
  /* box-shadow: 0px 1px 10px 0px rgba(14, 5, 10, 0.1); */
  overflow: hidden;
  border-right: 1px solid #eee;
}
/* 加粗标题 */
.boldTitle {
  font-weight: 700; font-size: 16px; color:#333;
}
.divBtn {
  height: 40px;
  text-align: right;
  margin-right: 20px;
}
/* 设置共创按钮 */
.setUpCoCreation {
  width: 260px;
  height: 35px;
  line-height: 33px;
  font-size: 14px;
  background-color: #F56C6C;
  border: 1px solid #F56C6C;
  text-align: center;
  color: #fff;
  border-radius: 3px;
  cursor: pointer;
  outline: none;
  margin-right: 10px;
}
/* 多图 */
.multigraph {
  width: 80px;
  height: 80px;
  position: relative;
  float:left;
  margin: 5px 10px 5px 0;
}
.chahao {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  text-align: center;
  line-height: 25px;
  color: #666;
  position: absolute;
  right: -8px;
  top: -8px;
  cursor: pointer;
}
.upBtn {
  width: 80px;
  height: 80px;
  line-height: 80px;
  border: 1px solid #DCDFE6;
  font-size: 26px;
  color: #999;
  margin: 5px 10px 5px 0;
}
/* 引客到店奖现金 & 创客分享奖现金 */
.threePrice {
  font-weight: normal;
  font-size: 13px;
  margin-left: 30px;
}
.imgDialog {
  width: 100%;
  height: 500px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
/* 视频 & 图片 集合 */
.videoandpic {
  width: 96%;
  margin: 10px auto;
  padding-left: 0;
  position: relative;
  display: inline-block;
}
.videoandpic>li{
  float: left;
  margin: 0 10px 5px 0;
  cursor: pointer;
  position: relative;
}
.mengceng {
  position: absolute;
  left: 30px;
  top: 30px;
  font-size: 40px;
  color: #666;
}
/* 活动配置 */
.ulhdpz{
  text-align: center;
}
.ulhdpz>li{
  width: 100%;
  height: 50px;
  line-height: 50px;
  cursor: pointer;
  font-weight: bold;
  border-bottom: 1px solid #f2f2f2;
}
.ulhdpz>li:hover{
  background: #eee;
}
.active{
  background: #ecf5ff;
}
</style>


// WEBPACK FOOTER //
// activityFormList.vue?5cc06c05